"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleBarSkeletons = exports.ArticleBar = exports.TEST_ID_VIEW_MORE_LINK = exports.TEST_ID_ARTICLE_BAR = void 0;
var react_1 = __importStar(require("react"));
var theme_ui_1 = require("theme-ui");
var Button_1 = require("../../atoms/Button/Button");
var Article_1 = require("../../molecules/Article/Article");
var ArticleSkeleton_1 = require("../../molecules/Article/ArticleSkeleton");
var articleBarCalculations_1 = require("./articleBarCalculations");
exports.TEST_ID_ARTICLE_BAR = "article-bar";
exports.TEST_ID_VIEW_MORE_LINK = "view-more";
function ArticleBar(_a) {
    var _b, _c;
    var csx = _a.csx, articles = _a.articles, title = _a.title, viewMoreCopy = _a.viewMoreCopy, viewMoreOnClick = _a.viewMoreOnClick;
    var barReference = react_1.useRef(null);
    var _d = react_1.useState(articleBarCalculations_1.calculateArticlesToShow((_c = (_b = barReference.current) === null || _b === void 0 ? void 0 : _b.clientWidth) !== null && _c !== void 0 ? _c : 0)), articlesToShow = _d[0], setArticlesToShow = _d[1];
    var numberOfArticles = articles.length;
    react_1.useLayoutEffect(function () {
        var handleResize = function () {
            var _a, _b;
            setArticlesToShow(articleBarCalculations_1.calculateArticlesToShow((_b = (_a = barReference.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0));
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        // Clear up event listener
        return function () { return window.removeEventListener("resize", handleResize); };
    }, [articles]);
    return (react_1.default.createElement(theme_ui_1.Flex, { ref: barReference, "data-testid": exports.TEST_ID_ARTICLE_BAR, sx: __assign({ justifyContent: "center" }, csx) },
        react_1.default.createElement(theme_ui_1.Flex, { sx: { flexDirection: "column" } },
            react_1.default.createElement(theme_ui_1.Flex, { sx: {
                    flexDirection: (articlesToShow >= 2) ? "row" : "column",
                    justifyContent: "space-between"
                } },
                title && react_1.default.createElement(theme_ui_1.Heading, { as: "h2" }, title),
                viewMoreCopy && viewMoreOnClick &&
                    react_1.default.createElement(Button_1.Button, { "data-testid": exports.TEST_ID_VIEW_MORE_LINK, onClick: viewMoreOnClick, variant: Button_1.ButtonVariant.TERTIARY, sx: { p: 0 } }, viewMoreCopy)),
            react_1.default.createElement(theme_ui_1.Flex, { sx: {
                    justifyContent: "center"
                } },
                articles.map(function (article, index) {
                    return (index <= articlesToShow - 1) ? (react_1.default.createElement(Article_1.Article, __assign({ key: index }, article, { articlePosition: articleBarCalculations_1.calculateArticlePosition(index, articlesToShow) }))) : null;
                }),
                react_1.default.createElement(ArticleBarSkeletons, { numberOfArticles: numberOfArticles, articlesToShow: articlesToShow })))));
}
exports.ArticleBar = ArticleBar;
function ArticleBarSkeletons(_a) {
    var numberOfArticles = _a.numberOfArticles, articlesToShow = _a.articlesToShow;
    return (react_1.default.createElement(react_1.default.Fragment, null, Array(Math.max(0, articlesToShow - numberOfArticles)).fill(0).map(function (value, index) { return (react_1.default.createElement(ArticleSkeleton_1.ArticleSkeleton, { key: index, articlePosition: articleBarCalculations_1.calculateArticlePosition(index + numberOfArticles, articlesToShow) })); })));
}
exports.ArticleBarSkeletons = ArticleBarSkeletons;
